/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Aborted_ToastInputs */



/**
* | output |
* | --- |
* | "Embed job was aborted" |
*
* @param {Embed_Captions_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_aborted_toast = /** @type {((inputs?: Embed_Captions_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La tache d'incrustation a ete annulee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Einbettungsvorgang wurde abgebrochen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il processo di incorporamento è stato interrotto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встраивание было прервано.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El trabajo de inserción fue cancelado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入作业已中止")
	if (locale === "ja") return /** @type {LocalizedString} */ ("埋め込みジョブが中止されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एम्बेड जॉब रद्द कर दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A tarefa de incorporação foi abortada.")
	return /** @type {LocalizedString} */ ("Embed job was aborted")
});